import dsdInstance from "./dsdInstance";
import {API_URL} from "../config/api";

export default class AppIntegrationService {

    static getAll = async () => {
        try {
            const res = await dsdInstance.get(API_URL.APP_INTEGRATION);
            return res.data.data.result;
        }
        catch (e) {
            console.error(e);
            return [];
        }

    }

    static delete = async id => {
        try {
            const res = await dsdInstance.delete(API_URL.APP_INTEGRATION + '/' + id);
            return res.data.data.result;
        }
        catch (e) {
            console.error(e);
        }
    }

    static create = async data => {
        try {
            const res = await dsdInstance.post(API_URL.APP_INTEGRATION, data)
            return res.data.data.result;

        }
        catch (e) {
            console.error('Invalid Response format', e)
        }
    }
    static update = async data => {
        try {
            const res = await dsdInstance.put(API_URL.APP_INTEGRATION, data)
            return res.data.data.result;

        }
        catch (e) {
            console.error('Invalid Response format', e)
        }
    }

}